var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('h1',{staticClass:"text-center text-5xl py-4 text-gray-900"},[_vm._v("Nicht Gefunden!")])])}]

export { render, staticRenderFns }